import IActionsResolver from 'globx/dist/Store/Interfaces/IActionsResolver';

import TimelineStatus   from './Constants/TimelineStatus';
import ITimelineActions from './Interfaces/ITimelineActions';
import Timeline         from './Timeline';

const resolveTimelineActions: IActionsResolver<Timeline, ITimelineActions> = (value: Timeline): ITimelineActions => ({
    track(nextMultiplier: number = -1): void {
        if (!value.isTracking) {
            value.timelineStatus = TimelineStatus.TRACKING;
        }

        if (nextMultiplier > -1) {
            value.multiplierProgress = nextMultiplier;
        }
    },

    scrub(nextMultiplier: number): void {
        if (!value.isScrubbing) {
            value.timelineStatus = TimelineStatus.SCRUBBING;
        }

        value.multiplierProgress = value.multiplierInspect = nextMultiplier;
    },

    inspect(nextMultiplier: number): void {
        value.multiplierInspect = nextMultiplier;
    },

    derivePlayback(nextPlayback): void {
        value.playback = nextPlayback;
    }
});

export default resolveTimelineActions;